// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"594":"about","597":"projects"}[chunkId] + "." + {"594":"e8ee0f05","597":"21e3ba3c"}[chunkId] + ".js";
};